import {Injectable} from "@angular/core";
import {GapiUser} from "./gapiuser";
import {ActivePromotionConfig} from "../config/active-promotion.config";

const CLIENT_ID = "970070305250-t677nl2t09sru8688bo2gk8i4stl6osb.apps.googleusercontent.com";
const KOBE_CLIENT_ID = "981341489334-88cvpbl2criis8tithad1fvmtuljppeb.apps.googleusercontent.com";
const API_KEY = "AIzaSyCaOrZPlbSGk4irhmvBwZsTKD2b7uwyR5g";
const KOBE_API_KEY = "AIzaSyBoQQ8vozrQpPvc8jUqaOoUqItBf8f1OOs";
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
let SCOPES = ['https://www.googleapis.com/auth/drive'].join(' ');

@Injectable()
export class GapiSession {
    googleAuth: gapi.auth2.GoogleAuth;

    constructor() {
    }

    initClient() {
        return new Promise((resolve, reject) => {
            gapi.load('client:auth2', () => {
                return gapi.client.init({
                    apiKey: ActivePromotionConfig.remote ? KOBE_API_KEY : API_KEY,
                    clientId: ActivePromotionConfig.remote ? KOBE_CLIENT_ID : CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES,
                }).then(() => {
                    this.googleAuth = gapi.auth2.getAuthInstance();
                    resolve(undefined);
                });
            });
        });
    }

    isSignedIn(): boolean {
        return false;
        //return this.googleAuth.isSignedIn.get();
    }

    signIn() {
        return this.googleAuth.signIn({
            prompt: 'consent'
        }).then((googleUser: gapi.auth2.GoogleUser) => {
            localStorage.setItem("gapiuser", JSON.stringify(GapiUser.fromBasicProfile(googleUser.getBasicProfile())));
        });
    }

    signOut(): void {
        this.googleAuth.signOut();
        localStorage.removeItem("gapiuser");
    }
}
